import type { ContractUpdate } from "@/app/contract-updates/types";

/**
 * The credit note a price decrease writes, as the client is told before accepting it.
 *
 * It only covers what the client paid or was billed above the new price, so it can be less than
 * the decrease, or nothing at all (FD-8190). Quoting `difference` there promised a credit note for
 * the whole decrease. An older API that doesn't send `credit` keeps the old figure.
 */
export const contractUpdateCredit = (
  contractUpdate: Pick<ContractUpdate, "difference" | "credit">
): number =>
  typeof contractUpdate.credit === "number"
    ? contractUpdate.credit
    : contractUpdate.difference;
